var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_446_285)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6.25C4.66848 6.25 4.35054 6.3817 4.11612 6.61612C3.8817 6.85054 3.75 7.16848 3.75 7.5V17.5C3.75 17.8315 3.8817 18.1495 4.11612 18.3839C4.35054 18.6183 4.66848 18.75 5 18.75H19C19.3315 18.75 19.6495 18.6183 19.8839 18.3839C20.1183 18.1495 20.25 17.8315 20.25 17.5V7.5C20.25 7.16848 20.1183 6.85054 19.8839 6.61612C19.6495 6.3817 19.3315 6.25 19 6.25H5ZM3.05546 5.55546C3.57118 5.03973 4.27065 4.75 5 4.75H19C19.7293 4.75 20.4288 5.03973 20.9445 5.55546C21.4603 6.07118 21.75 6.77065 21.75 7.5V17.5C21.75 18.2293 21.4603 18.9288 20.9445 19.4445C20.4288 19.9603 19.7293 20.25 19 20.25H5C4.27065 20.25 3.57118 19.9603 3.05546 19.4445C2.53973 18.9288 2.25 18.2293 2.25 17.5V7.5C2.25 6.77065 2.53973 6.07118 3.05546 5.55546Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.37604 7.08405C2.60581 6.73941 3.07146 6.64628 3.4161 6.87604L12.0001 12.5987L20.5841 6.87604C20.9287 6.64628 21.3944 6.73941 21.6241 7.08405C21.8539 7.4287 21.7608 7.89435 21.4161 8.12412L12.4161 14.1241C12.1642 14.2921 11.836 14.2921 11.5841 14.1241L2.58405 8.12412C2.23941 7.89435 2.14628 7.4287 2.37604 7.08405Z",
    fill: "#B5B5B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_446_285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.52a2130c873564cb18a2fa0cd9c92c76.svg";
export { ForwardRef as ReactComponent };